import register from 'ShopUiBundle/modules/app/registry';
import './bullets-chooser.scss';

// tslint:disable-next-line
register('bullets-chooser', () => import(/* webpackMode: "lazy" */'./bullets-chooser'));
